import { FC, memo } from 'react';

import { PointsListCheckboxGroupPointType } from 'application/components/PointItemContent/types';
import { PlayerSupportedFeatures } from 'application/pages/constants';

import IconMapPin from '@zvuk-b2b/react-uikit/ui/icons/MapPin';

import { TEXTS } from './texts';

import styles from './index.module.scss';
import { DEVICE_TEXTS } from './consts';

interface PointAddressesItemProps {
  point: PointsListCheckboxGroupPointType;
  allDevicesOfPointsHasVideoSupport: boolean;
}

const PointAddressItem: FC<PointAddressesItemProps> = ({ point, allDevicesOfPointsHasVideoSupport }) => {
  const hasDevice = Boolean(point.device);
  const hasVideoSupport = point.device?.supportedFeatures.includes(PlayerSupportedFeatures.VideoSupport);
  const deviceType = point.device?.type;
  let deviceTypeText = TEXTS.DEFAULT;

  if (deviceType) {
    deviceTypeText = DEVICE_TEXTS[deviceType];
  }

  return (
    <div
      key={point.id}
      className={styles.row}>
      <IconMapPin className={styles.icon} />

      <div>
        <div>{point.address || point.title}</div>

        {hasDevice && !allDevicesOfPointsHasVideoSupport && (
          <div className={hasVideoSupport ? styles.withDevice : styles.withoutVideoSupport}>
            {hasVideoSupport
              ? `${TEXTS.DEVICE_TYPE}: ${deviceTypeText}`
              : `${TEXTS.DEVICE_TYPE}: ${deviceTypeText}, ${TEXTS.NO_VIDEO}`}
          </div>
        )}

        {!hasDevice && !allDevicesOfPointsHasVideoSupport && (
          <div className={styles.withoutDevice}>{`${TEXTS.DEVICE_TYPE}: ${TEXTS.NO_DEVICE}`}</div>
        )}
      </div>
    </div>
  );
};

export default memo(PointAddressItem);
